import { useIntl } from 'react-intl';
import { useHref } from 'react-router';

import Alert from '../Alert';
import useAuth from '../AppLayout/hooks/useAuth';

const SUPPORT_PATH = '/support-and-feedback';

const SignInChangeBanner = () => {
  const intl = useIntl();
  const supportHref = useHref(SUPPORT_PATH);
  const { initialized, authenticated } = useAuth();

  if (!initialized || authenticated) return null;

  return (
    <Alert
      mode='informative'
      title={intl.formatMessage({ id: 'signInChangeBannerTitle' })}
      text={intl.formatMessage({ id: 'signInChangeBannerText' })}
      link1Props={{
        href: supportHref,
        label: intl.formatMessage({ id: 'signInChangeBannerLink' }),
      }}
      style={{ marginBottom: '1rem' }}
    />
  );
};

export default SignInChangeBanner;
